/* ------------------------------------------------------------------
   Carte interactive d'UNE boutique, pour la section Rolex Static Map.
   Un seul marqueur : la boutique de la page courante. Les autres
   points de vente ne sont volontairement pas affichés (la carte
   multi-boutiques vit dans sections/rolex-contact-locator.liquid).
   Le style de carte est celui déjà utilisé par assets/contact-list.js.
------------------------------------------------------------------ */
(function () {
  var ROLEX_MAP_STYLES = [
    { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
    { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
    { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
    { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
    { featureType: "poi", elementType: "labels.text", stylers: [{ visibility: "off" }] },
    { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { featureType: "poi.business", stylers: [{ visibility: "off" }] },
    { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#cfe1d3" }] },
    { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
    { featureType: "road", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
    { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
    { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
    { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
    { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
    { featureType: "transit", stylers: [{ visibility: "off" }] },
    { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
    { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#c2d9e1" }] },
    { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }, { visibility: "simplified" }] }
  ];

  var PIN = 'https://cdn.shopify.com/s/files/1/0767/8237/1000/files/map-location-pin-green-button_1.png?v=1737021956';

  var LABELS = {
    fr: { zoomIn: 'Zoom avant', zoomOut: 'Zoom arrière' },
    en: { zoomIn: 'Zoom in', zoomOut: 'Zoom out' }
  };

  function labels() {
    var lang = (document.documentElement.lang || 'fr').slice(0, 2).toLowerCase();
    return LABELS[lang] || LABELS.en;
  }

  function makeZoomControl(map) {
    var l = labels();
    var wrapper = document.createElement('div');
    wrapper.className = 'rolex-maps-zoom-wrapper';

    var zoomIn = document.createElement('button');
    zoomIn.type = 'button';
    zoomIn.className = 'rolex-maps-zoom zoom-in-btn';
    zoomIn.setAttribute('aria-label', l.zoomIn);

    var zoomOut = document.createElement('button');
    zoomOut.type = 'button';
    zoomOut.className = 'rolex-maps-zoom zoom-out-btn';
    zoomOut.setAttribute('aria-label', l.zoomOut);

    wrapper.appendChild(zoomIn);
    wrapper.appendChild(zoomOut);

    zoomIn.addEventListener('click', function () { map.setZoom(map.getZoom() + 1); });
    zoomOut.addEventListener('click', function () { map.setZoom(map.getZoom() - 1); });

    return wrapper;
  }

  function initOne(el) {
    if (el.getAttribute('data-rolex-map-ready') === 'true') return;

    var lat = parseFloat(el.getAttribute('data-lat'));
    var lng = parseFloat(el.getAttribute('data-lng'));
    if (isNaN(lat) || isNaN(lng)) return;

    var zoom = parseInt(el.getAttribute('data-zoom'), 10);
    if (isNaN(zoom)) zoom = 16;

    var center = new google.maps.LatLng(lat, lng);

    var map = new google.maps.Map(el, {
      zoom: zoom,
      center: center,
      minZoom: 5,
      maxZoom: 19,
      disableDefaultUI: true,
      streetViewControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      gestureHandling: 'cooperative',
      styles: ROLEX_MAP_STYLES
    });

    /* Zoom en bas a droite, comme sur la carte de la page contact. */
    map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(makeZoomControl(map));

    new google.maps.Marker({
      position: center,
      map: map,
      icon: PIN,
      clickable: false,
      title: el.getAttribute('data-title') || ''
    });

    el.setAttribute('data-rolex-map-ready', 'true');
    el.classList.add('is-ready');
  }

  window.initRolexStoreMap = function () {
    var nodes = document.querySelectorAll('.rolex-store-map');
    for (var i = 0; i < nodes.length; i++) initOne(nodes[i]);
  };

  /* Consentement marketing refusé (Complianz) : on masque la carte Google,
     l'image statique de la boutique reste affichée dessous. */
  document.addEventListener('cmplz_fire_categories', function (e) {
    var categories = (e && e.detail && e.detail.categories) || [];
    if (categories.indexOf('marketing') !== -1) return;
    var nodes = document.querySelectorAll('.rolex-store-map');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].classList.remove('is-ready');
      nodes[i].style.display = 'none';
    }
  });
})();